<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title(style="width: 100%;")
        v-layout.pa-0.ma-0(row)
          StatusIndicator.ma-2(positive pulse v-if="updateInfo")
          h1.subheading {{ $t('labels.toDay') }} {{ $t('pageHeader.activity') }}
          v-spacer
          h1.subheading {{ activitys.length }}
    v-card-text.list-500
      v-progress-linear(v-if="isLoading" size="70" width="7" indeterminate)
      v-layout(column v-if="!isLoading")
        template(v-for="(row, index) in activitys")
          v-layout.pointer(column @click="viewLocationNewTab(row)")
            v-flex.pb-0
              v-layout
                v-flex.font-weight-medium.green--text {{ row.activity }}
                v-spacer
                v-flex.caption.text-xs-right(color="text--gray") {{ row.createdAt | moment("from", "now") }}
            v-flex.pt-0
              v-layout
                v-flex
                  span.caption.list-line {{ row.data }}
                  span.caption.list-line.ml-1.red--text(v-if="row.userName") by: {{ row.userName }}
          v-divider(v-if="index + 1 < activitys.length" :key="index")

</template>

<script>
import dashbaordService from '../service.js'
import { StatusIndicator } from 'vue-status-indicator'
// import 'vue-status-indicator/styles.css'

export default {
  data() {
    return {
      activitys: [],
      isLoading: true,
      updateInfo: false,
    }
  },
  sockets: {
    activity(data) {
      // this.activitys.unshift(data)
      this.getAll()
      this.updateInfo = true
    },
  },
  mounted() {
    this.getAll()
  },
  components: {
    StatusIndicator
  },
  methods: {
    viewLocationNewTab(row) {
      let url = null
      switch(row.typeId) {
        case 1:
          url = '/location/profile'
          break;
        case 2:
          url = '/organization/profile'
          break;
        case 3:
          url = '/tickets/profile'
          break;
        case 4:
          url = '/leads/profile'
          break;
        default:
          url = 'none'
      }
      if (url !== 'none' ) {
        this.$router.push({ path: `${url}/${row.fromId}` })
        this.updateInfo = false
        // let routeData = this.$router.resolve({ path: `${url}/${row.fromId}` });
        // window.open(routeData.href, '_blank');
      }

    },
    getAll() {
      return dashbaordService.getLastActivity()
      .then(result => {
        this.activitys = result.data
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
</style>
